import React from 'react'
import { useWindowDimensions, ScrollView, View, ImageBackground, Image } from 'react-native'
import { Text, Button } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import { useMediaQuery } from 'react-responsive'
import RenderHtml from 'react-native-render-html'
import YoutubePlayer from "react-native-youtube-iframe"

import Colors from '../constants/Colors'

import { SafeAreaView } from 'react-native-safe-area-context'
import Swiper from 'react-native-web-swiper'
import FooterMenu from '../components/FooterMenu'

const source1 = {
  html: `
<ul>
<li>ATENDIMENTO REMOTO</li>
<li>GRATUITO</li>
<li>VAGAS LIMITADAS</li>
</ul>
`
};

const source2 = {
  html: `
<ul>
<li>CARAVANA GROWTH</li>
<li>GRATUITO</li>
<li>VAGAS LIMITADAS</li>
</ul>
`
};

export default function Home({navigation}) {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height

  const _goForm = () => {
    navigation.navigate('FormRD', {})
//    Linking.openURL('https://docs.google.com/forms/d/e/1FAIpQLSclP-vGIjG0gj9MtWVaWq21AAcHxuBhAVETRdPLAacHsgdYCA/viewform?vc=0&c=0&w=1&flr=0')
  }

  const _goFormCaravana = () => {
    navigation.navigate('Caravana', {})
//    Linking.openURL('https://docs.google.com/forms/d/e/1FAIpQLSclP-vGIjG0gj9MtWVaWq21AAcHxuBhAVETRdPLAacHsgdYCA/viewform?vc=0&c=0&w=1&flr=0')
  }

  const divisor = () => (
    <View style={{marginTop: isLargeScreen ? 300 : 420}}>
    <ImageBackground source={require(isLargeScreen ? '../assets/images/divisor_d.svg' : '../assets/images/divisor.svg')} style={{width: windowWidth, height: isLargeScreen ? 200 : 220, alignSelf: 'center'}} resizeMode="contain">
      {!isLargeScreen &&
      <View style={[tailwind('mx-5 self-center'), {marginTop: isLargeScreen ? 50 : 60}]}>
        <Text style={[tailwind('mt-5 text-lg font-bold self-center'), {color: Colors.roxo}]}>Programa</Text>
        <Text style={[tailwind('mt-0 text-lg font-bold self-center'), {color: Colors.roxo}]}>Growth - Crescimento Acelerado</Text>
        <Button size="large" style={[tailwind('self-center mt-2'), {marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
      </View>}
      {isLargeScreen &&
        <View style={[tailwind('mx-5 flex-row justify-between'), {marginTop: isLargeScreen ? 50 : 60}]}>
          <View>
            <Text style={[tailwind('mx-5 mt-5 text-lg font-bold self-start'), {color: Colors.roxo}]}>PROGRAMA</Text>
            <Text style={[tailwind('mx-5 mt-0 text-lg font-bold self-start'), {color: Colors.roxo}]}>Growth - Crescimento Acelerado</Text>
          </View>
          <Button nativeID="btn" size="large" style={[tailwind('mt-6'), {marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/5}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
      </View>}
      </ImageBackground>
  </View>)


      return (
        <SafeAreaView style={{flex:1, backgroundColor: "#ece7e7"}}>
          {!isLargeScreen &&
        <View style={{width: windowWidth, height: 80, backgroundColor: Colors.roxo}}>
          <Image source={require('../assets/images/logo_h.svg')} style={{width: isLargeScreen ? windowWidth-220 : windowWidth-140, height: 80, alignSelf: 'center'}} resizeMode="contain" />
        </View>}
        <View style={{width: windowWidth, height: 10, backgroundColor: Colors.laranja_forte}} />
          <ScrollView style={{height: windowHeight-85, width: windowWidth}} contentContainerStyle={{height: isLargeScreen ? windowHeight - 150 : windowHeight+230, width: windowWidth}}>
          <Swiper 
            loop 
            timeout={5}   
            controlsProps={{
                prevTitle: '<',
                nextTitle: '>'
            }}>
            <View>
              <ImageBackground source={require(isLargeScreen ? '../assets/images/bvd1.jpg' : '../assets/images/bv1.jpg')} style={{width: windowWidth, height: isLargeScreen ? 400 : 500}} resizeMode="cover">
                {divisor()}
              </ImageBackground>
            </View>
            <View>
              <ImageBackground source={require(isLargeScreen ? '../assets/images/bvd2.jpg' : '../assets/images/bv2.jpg')} style={{width: windowWidth, height: isLargeScreen ? 400 : 500}} resizeMode="cover">
                {divisor()}
              </ImageBackground>
            </View>
            <View>
              <ImageBackground source={require(isLargeScreen ? '../assets/images/bvd3.jpg' : '../assets/images/bv3.jpg')} style={{width: windowWidth, height: isLargeScreen ? 400 : 500}} resizeMode="cover">
                {divisor()}
              </ImageBackground>
            </View>
          </Swiper>
          {!isLargeScreen &&
            <View style={tailwind('mx-5 mt-2')}>
              <YoutubePlayer
                height={190}
                width={windowWidth - 50}
                videoId={"XhK4kitz7O0"}
              />
            </View>
            }
          <View style={tailwind('flex-row mt-5')}>
            <View style={tailwind('mx-5 self-center')}>
              <RenderHtml
                contentWidth={100}
                source={source1}
              />
              <Button nativeID="btn" size="small" style={[tailwind('mt-6 self-center'), {borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/5}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>PARTCIPE</Text></Button>
            </View>  
            {isLargeScreen &&
            <View style={tailwind('mx-5')}>
              <YoutubePlayer
                height={350}
                width={600}
                videoId={"XhK4kitz7O0"}
              />
            </View>
            }
          </View>
          </ScrollView>
          <FooterMenu />
        </SafeAreaView>
      )


}
